import React from 'react';

const Login = () => {
    return <h2>Please use above Login link to get authorized</h2>;
};

export default Login;
